module.exports = __webpack_public_path__ + "img/oog_open.128ef999.png";